export default [

     {
          path: '/control-phase',
          name: 'ControlPhase',
          component: () => import("@/views/Page/ControlPhase/ControlPhase.vue"),
           meta: {
               title: '#Default# | ControlPhase',
          },
     }
];